export const prepareStudent = (student) => {
    // Handle activationStatus conversion (soft conversion — NOT validation)
    const rawStatus = student.activationStatus?.toString().toLowerCase();
    const activationStatus = rawStatus === "true" ? true : rawStatus === "false" ? false : null;

    return {
        studentId: parseInt(student.studentId, 10),
        firstName: student.firstName || '',
        lastName: student.lastName || '',
        email: student.email || '',
        phoneNumber: student.phoneNumber || '',
        studentAddress: student.studentAddress || '',
        classes: student.classes || '',
        studentCreationDate: student.studentCreationDate || null,
        activationStatus
    };
};


